/* RESPONSIBLE TEAM: team-ai-insights */

import { TrendingTopicImpact, TrendingTopicTimeTrend } from './trending-topics-data-resources';

const IMPACT_TRANSLATION_KEY_MAP: Record<TrendingTopicImpact, string> = {
  [TrendingTopicImpact.Positive]: 'positive',
  [TrendingTopicImpact.Negative]: 'negative',
  [TrendingTopicImpact.Neutral]: 'neutral',
  [TrendingTopicImpact.Unknown]: '',
};

const TIME_TREND_TRANSLATION_KEY_MAP: Record<TrendingTopicTimeTrend, string> = {
  [TrendingTopicTimeTrend.IncreasingTrend]: 'increasing-trend',
  [TrendingTopicTimeTrend.DecreasingTrend]: 'decreasing-trend',
  [TrendingTopicTimeTrend.Flat]: 'flat-trend',
  [TrendingTopicTimeTrend.SingleWeekAnomaly]: 'event',
  [TrendingTopicTimeTrend.Unknown]: '',
};

export { IMPACT_TRANSLATION_KEY_MAP, TIME_TREND_TRANSLATION_KEY_MAP };
